import type { TimelineEvent } from "@/types/melon";

type ArticleTimelineProps = {
  events: TimelineEvent[];
};

export default function ArticleTimeline({ events }: ArticleTimelineProps) {
  return (
    <ol className="relative mt-8 border-l border-background-300 pl-6 md:pl-8">
      {events.map((event, index) => (
        <li key={`${event.at}-${index}`} className="relative pb-8 last:pb-0">
          <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 bg-accent-500 md:-left-[39px]"></span>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex flex-wrap items-center gap-3">
              <span className="rounded-full bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-800">
                {event.at}
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">{event.title}</h3>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{event.detail}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}